// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '위더스제약',
  targetSheetName: '품목별정책',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '제품코드',
    drugName: '제품명',
    commissionRate: '수수료 (%)',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No',
    '구분',
    '성분 · 함량',
    '제품코드',
    '제품명',
    '약가 (원)',
    '수수료 (%)',
    '오리지널',
    '비고',
    '생동여부',
  ],
});
